import React from "react";
import { Form } from "react-bootstrap";

export default function ModelSelector({ models = [], value, onChange, disabled, compact }) {
  return (
    <Form.Select
      size="sm"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      style={{ maxWidth: compact ? 120 : 240 }}
      className={compact ? "form-select-sm" : ""}
    >
      {models.map((model) => (
        <option key={model.id} value={model.id}>
          {model.label || model.id}
        </option>
      ))}
    </Form.Select>
  );
}
